/**
 * Used to hanlde API error.
 * such as: eror 500, etc..
 *
 */

import {createSetters} from 'map-state-vmodel'

// initial state
const state = {
  show_error: false,
  error_code: null, // FIXME must be null
  response_code: [
    { code: 400 ,status: 'Bad Request', description: 'The request was invalid.' },
    { code: 401 ,status: 'Unauthorized', description: 'The request did not include an authentication token or the authentication token was expired.' },
    { code: 403 ,status: 'Forbidden', description: 'The client did not have permission to access the requested resource.' },
    { code: 404 ,status: 'Not Found', description: 'The requested resource was not found.' },
    { code: 405 ,status: 'Method Not Allowed', description: 'The HTTP method in the request was not supported by the resource. For example, the DELETE method cannot be used with the Agent API.' },
    { code: 409 ,status: 'Conflict', description: 'The request could not be completed due to a conflict. For example,  POST ContentStore Folder API cannot complete if the given file or folder name already exists in the parent location.' },
    { code: 500 ,status: 'Internal Server Error', description: 'The request was not completed due to an internal error on the server side.' },
    { code: 503 ,status: 'Service Unavailable', description: 'The server was unavailable.' },
  ],
  server_down: false,
  
};

// getters
const getters = {
  getResponse: state => {
    return state.response_code.find(response => response.code === state.error_code)
  }
};

// actions
const actions = {};

// mutations
const mutations = {
  ...createSetters(state)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
